<mat-button-toggle-group
  *ngIf="value && options"
  [value]="value"
  (change)="valueChange.emit($event.value)">
  <mat-button-toggle
    *ngFor="let opt of options"
    class="tw-text-sm tw-font-medium tw-text-grey-400 tw-h-9 fx-center"
    [value]="opt.value">
    {{ opt.label }}
  </mat-button-toggle>
</mat-button-toggle-group>